import * as React from 'react';

import { CTA_TARGET_COURSERA_PLUS_CHECKOUT_PAGE } from 'bundles/promo-template/contentful/modules/constants';
import { EXPLORE_PAGE_COURSERA_PLUS_CAMPAIGN_SLUGS } from 'bundles/promo-template/contentful/modules/constants/courseraPlusCampaignSlugs';
import { usePromoTemplateContext } from 'bundles/promo-template/contexts/PromoTemplateContext';

const useEnrollOrUpgradeToCPlusButton = ({
  slug,
  ctaTarget,
  button,
}: {
  slug?: string | undefined;
  ctaTarget?: string | null;
  button: React.ReactElement;
}) => {
  const isCourseraPlusCampaign = EXPLORE_PAGE_COURSERA_PLUS_CAMPAIGN_SLUGS.includes(slug as string);
  const { isFirstButtonCheckActionParamsRef } = usePromoTemplateContext();

  let customPrimaryCta;

  // if the ctaTarget is cplus-checkout-page, render the EnrollOrUpgradeToCourseraPlus component
  if (isCourseraPlusCampaign || ctaTarget === CTA_TARGET_COURSERA_PLUS_CHECKOUT_PAGE) {
    customPrimaryCta = React.cloneElement(button, {
      shouldCheckActionParams: !isFirstButtonCheckActionParamsRef.current,
    });

    if (isFirstButtonCheckActionParamsRef.current === false) {
      isFirstButtonCheckActionParamsRef.current = true;
    }
  }

  return customPrimaryCta;
};

export default useEnrollOrUpgradeToCPlusButton;
